(function($){
  	// This is a little function to move the play button to the top of the banner on the mobile homepage.

  	var movePlay = function() {
  		// If the window is narrower than 767px and we are on the front page (we know this
  		// because .playbutton exists
  		if($(window).width() <= 767 && $('.playbutton').length) {
  			$('.playbutton').insertBefore('.videoheadline').addClass('playbuttonmobile');
  		}
  	}



  	$(document).on('ready', function() {
	  <!-- movePlay(); -->

      if($(window).width() <= 767 && $('.page-sidebar').length) {
          $('.sidebar').insertAfter('.page');
      }

      // Rearrange elements on the front page
      if($(window).width() <= 767 && $('.index').length) {
          $('#slide-1').addClass('white-border');
          $('#featured_products').insertAfter('#slide-1');
          $('#slide-4').insertAfter('#featured_products');
          $('#slide-4').addClass('white-border');
          $('#slide-3').insertAfter('#slide-4');
          // $('.featured_products').insertAfter('#slide-3');
      }

      if($(window).width() <= 767 && $('.modal').length) {

          $( ".modal" ).each( function( index, element ){
               $description = $( this ).find('.product_description');
               $more = $(this).find('.product_description_read_more');
               $form = $(this).find('.product_form');
               $description.insertAfter($form);

               $more.insertAfter($description);

               $more.on('click', function(e) {

                   e.preventDefault();

                   $(this).siblings('.product_description').toggleClass('active');

                   if($more.text() === 'Read more') {
                       $more.text('Read less');
                   } else {
                       $more.text('Read more');
                   }
               });
          });

      }

      if($(window).width() <= 767 && $('.page-parallax').length && $('.video-container').length) {
          $('.video-container').closest('.hsContainer').css('min-height', '0').css('padding-top', '0').css('padding-bottom', '0');
      }

      $('.fancybox').fancybox();
      
       $('.fancybox.quickshop').fancybox({
        afterShow: function() {
          var path = '/#checkout-popup';
          var title = this.content.find('h3').text() + ' Popup';
      
      	   // send popup as pageview    
           ga('set', { page: path, title: title });
           ga('send', 'pageview');
          
           // track button click
           $('.fancybox-wrap button[type="submit"]').on('click', function(e) {
             var text = $(e.currentTarget).closest(".fancybox-inner").find("h3").text();
               ga('send', 'event', {
                  eventCategory: 'Button',
                  eventAction: 'click',
                  eventLabel: 'Complete Your Order',
                  eventValue: text,
                  transport: 'beacon'
              	});
                     
        	});
        }
      });
      
      // track button click
      $('.fancybox.quickshop').on('click', function(e){ 
        ga('send', 'event', 'Button', 'click', 'Buy Now', $(e.currentTarget).find('.subtitle').text());
      });
           

  	});

})(jQuery);